import createHashHistory from "history/createHashHistory";
import createBrowserHistory from "history/createBrowserHistory";
let history;
if (document.getElementById("jsReactApp")) {
    history = createHashHistory();
} else {
    history = createBrowserHistory();
}
export default history;